import { addIconGlassLg } from '@tpct/icons';

type AddItemIconProps = {
  className?: string;
};

/** Same asset as report theme "add" cards; use for generic add / empty dropzones. */
export const addItemIconUrl = addIconGlassLg;

export const AddItemIcon = ({ className }: AddItemIconProps) => (
  <img src={addIconGlassLg} alt="" aria-hidden="true" className={className} />
);
